import React from 'react';
import { ZoneMapUsecaseLabelEnum } from 'common/enums/ZoneMapUsecaseLabelEnum';
import theme from './ZoneMapUsecaseLabel.scss';

const ZoneMapUsecaseLabel = ({ usecase }) => {
    const label = ZoneMapUsecaseLabelEnum[usecase];
    return label ? <div className={theme.usecaseBadge}>{label}</div> : null;
};

export default ZoneMapUsecaseLabel;
